import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const faqs = [{
  q: 'Is this legal?',
  a: 'Yes. You are simply offering professional services as an independent contractor.'
}, {
  q: 'Do I need an LLC first?',
  a: 'No. You can start as a sole proprietor and set up the legalities once the first check clears.'
}, {
  q: "What if I'm not a 'salesperson'?",
  a: "This isn't about selling; it's about diagnosing a problem. If you can explain code, you can explain a solution."
}, {
  q: 'How much time does this take?',
  a: 'The daily outreach rhythm takes roughly 2 hours.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section id="faq" className="py-24 bg-zinc-900 border-t border-zinc-800" data-id="element-15">
      <div className="max-w-3xl mx-auto px-6 md:px-12" data-id="element-16">
        <div className="text-center mb-16" data-id="element-17">
          <h2 className="font-display text-4xl md:text-5xl text-zinc-100" data-id="element-18">
            FREQUENTLY ASKED <span className="text-teal-500" data-id="element-19">QUESTIONS</span>
          </h2>
        </div>

        <div className="space-y-4" data-id="element-20">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="border border-zinc-800 bg-zinc-950 rounded-lg overflow-hidden" data-id="element-21">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" data-id="element-22">
                  <span className="text-lg font-bold text-zinc-100" data-id="element-23">
                    {faq.q}
                  </span>
                  {isOpen ? <Minus className="w-5 h-5 text-teal-500 shrink-0" data-id="element-24" /> : <Plus className="w-5 h-5 text-zinc-500 shrink-0" data-id="element-25" />}
                </button>
                <AnimatePresence data-id="element-26">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-27">
                      <div className="px-6 pb-6 text-zinc-400 leading-relaxed" data-id="element-28">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}